
import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { HiOutlineArrowRight, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import "../../../../style/MyAccount-ticket/universal-line-ticket.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import useOpenToSelect from "../hooks/useOpenToSelect";
import useFacility from "../../../../utils/hooks/useFacility";
import SelectPassBar from "../selectPass/selectPassBar";
import SelectPassModalFooter from "../selectPass/selectPassModalFooter";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SingleExercise from "../selectPass/singleExercise";

interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}

const LimitedOpenPassMobile: React.FC<IProps> = ({ ticket,getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
    const facilityIds = useFacility();
    const { addPossibilityToJoin } = useOpenToSelect();
  const [allowToJoin, setAllowToJoin] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );
  
  useEffect(() => {
    if (facilityIds === "1212") {
      setAllowToJoin(addPossibilityToJoin(ticket))
    }
  }, [facilityIds]);

  return (
    <React.Fragment>
      {ticket.passtype !== 2 && ticket.ticket === false && (
        <div className="line-vertical flex-column">
          <div className="line-vertical-head flex-start-center">
            <HiOutlineTicket className="big-icon" />
            <b>{ticket.name}</b>
          </div>

          <div className="line-vertical-horizontal-line"></div>
          {/*  CONTENT */}
          <div className="line-vertical-content">
            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />
              <b>
                {t("wazny_od")}: {format(ticket.validfrom, "dd.MM")}
              </b>
            </div>

            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />
              <b>
                {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}
              </b>
            </div>

            <div className="line-vertical-content-arg">
              <HiOutlineArrowRight className="icon" />
              {ticket.entrances - ticket.exercises.length > 1000 ? (<b>{t("pozostalo")}: bez limitu {t("wejsc")}</b>) : (<b> {t("pozostalo")}: {ticket.entrances - ticket.exercises.length} {t("wejsc")}</b>)}

            </div>
          </div>
          {/*  CONTENT */}
          <div className="line-vertical-buttons">

          {allowToJoin && (

<button
  onClick={() => setAssignedList(!open)}
  className="button padding-medium medium button-fill-background-main full-button"
>
  {t("pokaz_terminy")}
</button>

)}


            <button
              onClick={() => setOpen(!open)}
              className="button padding-medium medium button-fill-main full-button"
            >
              {t("pokaz_kod_qr")}
              <HiQrcode className="icon" />
            </button>
          </div>
        </div>
      )}

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}


{assignedList && (
        <ModalComponent
          footer={false}
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            <SelectPassBar ticket={ticket} />

       
              {ticket.exercises[0] && (
                <div>
                  {ticket.exercises.map((exercise, index) => (
                    <div key={index}>
                      <SingleExercise exercise={exercise} getSelect={getSelect} />
                    </div>
                  ))}
                </div>
              )}
            
            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>
        </ModalComponent>
      )}

    </React.Fragment>
  );
};

export default LimitedOpenPassMobile;
